export default "__VITE_ASSET__CK0087Jl__"